import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Commitment, LanguageId } from '@interfaces';

export function getColumns(util: UtilityService) {
	const columns: GridColumn<Commitment, unknown>[] = [
		buildColumn(util, 'Id', row => row.commitmentId),
		buildColumn(util, 'FullName', row => row.name, { header: 'Name' }),
		buildColumn(util, 'Number', row => row.startTrimesterId, { header: 'Start Trimester' }),
		buildColumn(util, 'Number', row => row.numTrimesters, { header: 'Total Trimesters' }),
		buildColumn(util, 'FullName', row => row.donorName, { header: 'Donor Name' }),
		buildColumn(util, 'Text', row => row.impact, { header: 'Impact' }),
		buildColumn(util, 'Dollar', row => row.dollars, { header: 'Dollars', hidden: true }),
		buildColumn(util, 'Number', row => row.graduatedVenturesPromised, { header: 'Entrepreneurs to Graduate' }),
		buildColumn(util, 'Number', row => Math.round(row.graduatedVenturesPromised * 1.1), { header: 'Entrepreneurs To Accept', hidden: true }),
		buildColumn(util, 'Text', row => row.languageId ? (row.languageId === LanguageId.English ? 'English' : 'Spanish') : 'Either', { header: 'Language' }),
		buildColumn(util, 'FullName', row => row.alignmentName, { header: 'Alignment Name' }),
		buildColumn(util, 'FullName', row => row.geographyName, { header: 'Geography Name', hidden: true }),
		buildColumn(util, 'Percent', row => row.matchRatio, { header: 'Match Ratio', hidden: true }),
		buildColumn(util, 'Percent', row => row.actualProgress, { header: 'Actual Progress', headerTooltip: 'Includes only Accepted Seats' }),
		buildColumn(util, 'Percent', row => row.potentialProgress, { header: 'Potential Progress', headerTooltip: 'Includes Actual Progress, plus Considers' }),
		buildColumn(util, 'Percent', row => row.urgency, { header: 'Urgency' }),
		buildColumn(util, 'Text', row => row.matchDifficulty, { header: 'Difficulty' }),
		buildColumn(util, 'Percent', row => row.matchDifficultyRatio, { header: 'Difficulty Ratio', hidden: true }),
	];
	return columns;
}